import { combineNullables } from "../util/combineNullables.js";
import type { BigFraction } from "./BigFraction.js";
import { FRACTION_ONE } from "./fraction.js";

const multiplyReducer = (acc: BigFraction, curr: BigFraction) => acc.mul(curr);

export const multiply = (
  fractions: Array<BigFraction | null>,
): BigFraction | null =>
  combineNullables(
    (..._fractions) => _fractions.reduce(multiplyReducer, FRACTION_ONE),
    ...fractions,
  );
